import { ContractorTitle, IconCalendarPerson } from '../../../../../../components/buttons/IconButtons';
import { useTranslation } from 'react-i18next';
import React, { useState } from 'react';
import {
    DeleteContractFromWorkShift,
    DeleteUserFromWorkShift,
} from '../../../../../../reduxToolkit/CompanyWorkShift/CompanyWorkShiftApi';
import { TABLES } from '../../../../../../Apis/Tables';
import { DeleteItemsApi } from '../../../../../../reduxToolkit/Commons/CommonsApi';
import { useDispatch } from 'react-redux';
import TableFunction from '../../../../../../components/table/TableFunction';
import { useEffect } from 'react';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle: Full Stack Developer - IBL
 * @Email: clopez@ibl.mx
 *
 */
const AccessRightsApp = ({
    workShiftsList,
    setWorkShiftsList,
    customizedList,
    setCustomizedList,
    contractorItemId,
    user,
}) => {
    const MODEL_TABS_ACCESS_RIGHT = {
        WORK_SHIFT: {
            ID: 1,
            NAME: 'WORK_SHIFT',
        },
        CUSTOM_SHIFT: {
            ID: 1,
            NAME: 'CUSTOM_SHIFT',
        },
    };

    const TABS_ACCESS_RIGHT = [
        {
            id: MODEL_TABS_ACCESS_RIGHT.WORK_SHIFT.ID,
            key: MODEL_TABS_ACCESS_RIGHT.WORK_SHIFT.NAME,
            translation: 'work_shift',
            icon: <IconCalendarPerson className='btn-icon-svg-20px icon-color-shades-400' />,
            textNoInfo: 'search_for_work_shift',
        },
        {
            id: MODEL_TABS_ACCESS_RIGHT.CUSTOM_SHIFT.ID,
            key: MODEL_TABS_ACCESS_RIGHT.CUSTOM_SHIFT.NAME,
            translation: 'custom_access',
            icon: <ContractorTitle className='btn-icon-svg-20px icon-color-shades-400' />,
            textNoInfo: 'search_for_custom_shift',
        },
    ];

    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [optionTabSelected, setOptionTabSelected] = useState(MODEL_TABS_ACCESS_RIGHT.WORK_SHIFT.NAME);
    const [selectedWorkShifts, setSelectedWorkShifts] = useState([]);
    const [selectedCustomized, setSelectedCustomized] = useState([]);

    const [isAllWorkShiftsChecked, setIsAllWorkShiftsChecked] = useState(false);
    const [isAllCustomizedChecked, setIsAllCustomizedChecked] = useState(false);

    const [deleteWorkShiftsModal, setDeleteWorkShiftsModal] = useState(false);
    const [deleteCustomizedModal, setDeleteCustomizedModal] = useState(false);

    const { handleCheckboxChange: handleWorkShiftCheckboxChange, handleDeleteAll: handleDeleteAllWorkShifts } =
        TableFunction({
            keyId: 'id',
            selectedList: selectedWorkShifts,
            setSelectedList: setSelectedWorkShifts,
            data: { content: workShiftsList },
            setIsAllChecked: setIsAllWorkShiftsChecked,
        });

    const { handleCheckboxChange: handleCustomizedCheckboxChange, handleDeleteAll: handleDeleteAllCustomized } =
        TableFunction({
            keyId: 'id',
            selectedList: selectedCustomized,
            setSelectedList: setSelectedCustomized,
            data: { content: customizedList },
            setIsAllChecked: setIsAllCustomizedChecked,
        });
   const handleWorkShiftsDelete = (index) => {
        const item = workShiftsList[index];
        if (contractorItemId === undefined) {
            deleteUserFromWorkShift(user.id, item, index);
        } else {
            deleteContractFromWorkShift(user.id, item, index);
        }
    }

    const handleCustomizedDelete = (index) => {
        const tableName = !contractorItemId ? TABLES.USER_WORK_SCHEDULE : TABLES.CONTRACTOR_WORK_SCHEDULE;
        const item = customizedList[index];
        deleteItemsApi(tableName, item, index);
    }
   const handleDeleteSelectedWorkShifts = () => {
    const items = workShiftsList.filter((item) => selectedWorkShifts.includes(item.id));
    const existingItems = items.filter((item) => !item?.new);

    const removeSelectedFromList = () => {
        setWorkShiftsList((prevList) => prevList.filter((item) => !selectedWorkShifts.includes(item.id)));
    };

    if (existingItems.length === 0) {
        // todos eran items nuevos (no guardados aún), no hay que llamar a la API
        removeSelectedFromList();
    } else {
        const data = contractorItemId === undefined
            ? { userIds: [user.id], workShiftIds: existingItems.map((item) => item.id) }
            : { contractorIds: [user.id], workShiftIds: existingItems.map((item) => item.id) };

        const action = contractorItemId === undefined
            ? DeleteUserFromWorkShift(data)
            : DeleteContractFromWorkShift(data);

        dispatch(action).then(({ payload: { data: { success } } }) => {
            if (success === true) {
                removeSelectedFromList();
            }
        });
    }

    setSelectedWorkShifts([]);
    setIsAllWorkShiftsChecked(false);
    setDeleteWorkShiftsModal(false);
};

const handleDeleteSelectedCustomized = () => {
    const tableName = !contractorItemId ? TABLES.USER_WORK_SCHEDULE : TABLES.CONTRACTOR_WORK_SCHEDULE;
    const items = customizedList.filter((item) => selectedCustomized.includes(item.id));
    const existingItems = items.filter((item) => !item?.new);

    const removeSelectedFromList = () => {
        setCustomizedList((prevList) => prevList.filter((item) => !selectedCustomized.includes(item.id)));
    };

    if (existingItems.length === 0) {
        removeSelectedFromList();
    } else {
        const body = existingItems.map((item) => item.id);
        dispatch(DeleteItemsApi({ tableName, body })).then(({ payload: { data: { success } } }) => {
            if (success === true) {
                removeSelectedFromList();
            }
        });
    }

    setSelectedCustomized([]);
    setIsAllCustomizedChecked(false);
    setDeleteCustomizedModal(false);
};

   const deleteUserFromWorkShift = (userId, item, index) => {
        if (!item?.new) {
            const data = {
                userIds: [userId],
                workShiftIds: [item.id],
            };
            dispatch(DeleteUserFromWorkShift(data)).then(({ payload: { data: { success } } }) => {
                if (success === true) {
                    setWorkShiftsList((prevList) => prevList.filter((item, i) => i !== index));
                }
            });
        } else {
            setWorkShiftsList((prevList) => prevList.filter((item, i) => i !== index));
        }
    }

    const deleteContractFromWorkShift = (contractorId, item, index) => {
        if (!item?.new) {
            const data = {
                contractorIds: [contractorId],
                workShiftIds: [item.id],
            };
            dispatch(DeleteContractFromWorkShift(data)).then(({ payload: { data: { success } } }) => {
                if (success === true) {
                    setWorkShiftsList((prevList) => prevList.filter((item, i) => i !== index));
                }
            });
        } else {
            setWorkShiftsList((prevList) => prevList.filter((item, i) => i !== index));
        }
    }

      const deleteItemsApi = (tableName, item, index) => {
        if (!item?.new) {
            const body = [item.id];
            dispatch(DeleteItemsApi({ tableName, body })).then(({ payload: { data: { success } } }) => {
                if (success === true) {
                    setCustomizedList((prevList) => prevList.filter((item, i) => i !== index));
                }
            });
        } else {
            setCustomizedList((prevList) => prevList.filter((item, i) => i !== index));
        }
    }

    return {
        t,
        MODEL_TABS_ACCESS_RIGHT,
        TABS_ACCESS_RIGHT,
        optionTabSelected,
        setOptionTabSelected,
        selectedWorkShifts,
        isAllWorkShiftsChecked,
        handleWorkShiftCheckboxChange,
        handleDeleteAllWorkShifts,
        selectedCustomized,
        isAllCustomizedChecked,
        handleCustomizedCheckboxChange,
        handleDeleteAllCustomized,
        deleteWorkShiftsModal,
        setDeleteWorkShiftsModal,
        setSelectedCustomized,
        setSelectedWorkShifts,
        setDeleteCustomizedModal,
        deleteCustomizedModal,
        handleDeleteSelectedCustomized,
        handleDeleteSelectedWorkShifts,
        handleCustomizedDelete,
        handleWorkShiftsDelete
    };
};

export default AccessRightsApp;
